<template>
    <div class="p-3 position-relative">
        <div class="d-flex justify-content-between">
            <p
                class="text-primary cursor-pointer"
                @click="
                    showUpload = true;
                    resetDocument();
                "
            >
                <i class="fa fa-upload mr-2"></i>Upload a New Document
            </p>
            <p
                class="text-primary cursor-pointer text-uppercase font-weight-bold"
                @click="showFilters = true"
            >
                <i class="fa fa-filter mr-2"></i>Filter
            </p>
        </div>

        <div class="form-row">
            <div class="col-6 col-sm-4">
                <input
                    class="form-control form-control-sm mb-2"
                    placeholder="Search for..."
                    type="text"
                    v-model="nameFilter"
                />
            </div>
        </div>

        <div class="row p-1 table-header">
            <div class="col-1 text-uppercase text-white">Date</div>
            <div class="col-3 text-uppercase text-white">Specialist</div>
            <div class="col-3 text-uppercase text-white">Report</div>
            <div class="col-3 text-uppercase text-white">Note</div>
            <div class="col-md-2"></div>
        </div>

        <div
            class="row table-row position-relative"
            :class="`${actionsOpen ? 'overlay' : ''}`"
            v-for="d in filteredDocuments"
        >
            <div class="col-1">
                <small>{{ moment(d.date).format("M-DD-YY") }}</small>
            </div>
            <div class="col-3">
                <small>{{ d.specialist_name }}<br />{{ d.specialist_type }}</small>
            </div>
            <div class="col-3">
                <div v-if="d.attaching_file || !d.file_url">
                    <input
                        class="form-control form-control-form-control-file btn"
                        type="file"
                        ref="documentFile"
                        @change="handleUpload($event, 'documentFile', d)"
                    />
                </div>
                <div v-else="">
                    <small>
                        <a target="_blank" :href="`${d.file_url}`">{{ d.title }}</a>
                    </small>
                    <i
                        @click="updateFile(d)"
                        class="fa fa-edit cursor-pointer mx-1 text-primary"
                    ></i>
                </div>
            </div>
            <div class="col-3">
                <small>{{ d.notes }}</small>
            </div>
            <div class="col-md-2">
                <i @click="edit(d)" class="fa fa-edit cursor-pointer mx-1 text-primary"></i>
                <i
                    @click="openDeleteAction(d)"
                    class="fa fa-times-circle-o cursor-pointer mx-1 text-primary"
                ></i>
            </div>
            <div
                class="actions position-absolute p-3 bg-white d-flex flex-column justify-content-center align-items-center"
                style="top:0.5rem; right:0.5rem; z-index:4;"
                v-if="d.actions"
            >
                <span
                    class="position-absolute cursor-pointer"
                    style="top:0.5rem; right:0.5rem; z-index:4;"
                    @click.stop="closeActionsMenu(d)"
                >
                    <i class="fa fa-close " style="color:#D64571"></i>
                </span>
                <p class="">Are you sure you want to delete this document?</p>
                <a
                    @click.stop="closeActionsMenu(d)"
                    class="btn btn-sm btn-primary font-weight-bold text-white text-uppercase btn-block m-1"
                    ><small>No, go back</small></a
                >
                <small class="font-weight-bold text-primary mt-2"
                    >Yes, I want to permanently delete this document</small
                >
                <button @click="deleteDocument(d)" class="btn btn-sm btn-danger" type="button">
                    Delete
                </button>
            </div>
        </div>
        <transition name="simple-fade">
            <div
                id="filters"
                class="pop-up position-absolute w-100 bg-white p-3"
                v-if="showFilters"
            >
                <i
                    class="position-absolute fa fa-times-circle-o fa-2x cursor-pointer"
                    @click="showFilters = false"
                    style="top: 2rem; right: 2rem; color:#D64571"
                ></i>
                <h3>Documentation Filters</h3>
                <p class="text-uppercase font-weight-bold">Specialist</p>
                <ul class="filter-options">
                    <li v-for="s in specialists" class="form-group mb-0">
                        <input type="checkbox" class="mr-2" :value="s" v-model="specialistFilter" />
                        <span>{{ s }}</span>
                    </li>
                </ul>
                <p class="text-uppercase font-weight-bold">Document Type</p>
                <ul class="filter-options">
                    <li v-for="d in docTypes" class="form-group mb-0">
                        <input type="checkbox" class="mr-2" :value="d" v-model="docTypeFilter" />
                        <span>{{ d }}</span>
                    </li>
                </ul>
            </div>
        </transition>

        <transition name="simple-fade">
            <div id="upload" class="pop-up position-absolute w-100 bg-white p-3" v-if="showUpload">
                <i
                    class="position-absolute fa fa-times-circle-o fa-2x cursor-pointer"
                    @click="showUpload = false"
                    style="top: 2rem; right: 2rem; color:#D64571"
                ></i>
                <h3>Documentation Upload</h3>

                <div class="form-row">
                    <div class="col-6 col-sm-4 d-flex flex-column justify-content-center">
                        <label for="date">Enter date document was created</label>
                    </div>
                    <div class="col-6 col-sm-4">
                        <v-date-picker
                            id="date"
                            :pane-width="50"
                            popover-align="left"
                            v-model="newDocument.date"
                        ></v-date-picker>
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-6 col-sm-4">
                        <label for="author">Who created the document</label>
                    </div>
                    <div class="col-6 col-sm-4">
                        <input
                            class="form-control form-control-sm mb-2"
                            placeholder="Document author"
                            id="author"
                            type="text"
                            v-model="newDocument.specialist_name"
                        />
                    </div>
                </div>
                <p class="text-uppercase font-weight-bold">Title or occupation of professional</p>
                <ul class="filter-options">
                    <li v-for="s in specialists" class="form-group mb-0">
                        <input
                            type="radio"
                            class="mr-2"
                            :value="s"
                            v-model="newDocument.specialist_type"
                        />
                        <span>{{ s }}</span>
                    </li>
                </ul>
                <p class="text-uppercase font-weight-bold">This document is or contains</p>
                <ul class="filter-options">
                    <li v-for="d in docTypes" class="form-group mb-0">
                        <input type="radio" class="mr-2" :value="d" v-model="newDocument.type" />
                        <span>{{ d }}</span>
                    </li>
                </ul>
                <div class="form-row">
                    <div class="col-6 col-sm-4">
                        <label for="title">Title of the document</label>
                    </div>
                    <div class="col-6 col-sm-4">
                        <input
                            class="form-control form-control-sm mb-2"
                            placeholder="Document title"
                            id="title"
                            type="text"
                            v-model="newDocument.title"
                        />
                    </div>
                </div>
                <div class="form-row">
                    <div class="col-6 col-sm-4">
                        <label for="notes">Notes</label>
                    </div>
                    <div class="col-6 col-sm-4">
                        <input
                            class="form-control form-control-sm mb-2"
                            placeholder="Document notes"
                            id="notes"
                            type="text"
                            v-model="newDocument.notes"
                        />
                    </div>
                </div>
                <a
                    v-if="is_edit"
                    class="btn btn-primary text-white text-uppercase font-weight-bold my-2 float-right"
                    @click="updateDocument()"
                    >Update document</a
                >
                <a
                    v-else=""
                    class="btn btn-primary text-white text-uppercase font-weight-bold my-2 float-right"
                    @click="addDocument()"
                    >Add document</a
                >
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "Documentation",
    props: ["patient"],
    data() {
        return {
            documents: [],
            specialists: [
                "OT - Occupational Therapist",
                "PT - Physical Therapist",
                "SLP - Speech & Language Therapist",
                "ABA - Applied Behavior Analytics",
            ],
            docTypes: [
                "Initial Assessment",
                "Progress Report",
                "IEP",
                "Test/Assessment Scores",
                "Official Evaluation",
                "Diagnostic Document",
                "Letter",
            ],
            showFilters: false,
            showUpload: false,
            nameFilter: "",
            specialistFilter: [],
            docTypeFilter: [],
            newDocument: {
                file: null,
                specialist_name: null,
                title: null,
                type: null,
                notes: null,
            },
            is_edit: false,
            actionsOpen: false,
        };
    },
    created() {
        this.getData();
    },
    mounted() {},
    computed: {
        filteredDocuments() {
            let filteredDocuments = this.documents;
            if (this.docTypeFilter.length) {
                filteredDocuments = filteredDocuments.filter(d =>
                    this.docTypeFilter.includes(d.type)
                );
            }
            if (this.specialistFilter.length) {
                filteredDocuments = filteredDocuments.filter(s =>
                    this.specialistFilter.includes(s.specialist_type)
                );
            }
            if (this.nameFilter.length) {
                filteredDocuments = filteredDocuments.filter(
                    n =>
                        n.title.toLowerCase().includes(this.nameFilter.toLowerCase()) ||
                        n.specialist_name.toLowerCase().includes(this.nameFilter.toLowerCase())
                );
            }
            return filteredDocuments;
        },
        isoDate() {
            return this.moment(this.newDocument.date, "MM-DD-YY").format("YYYY-MM-DD");
        },
    },
    methods: {
        openDeleteAction(document) {
            Vue.set(document, "actions", true);
            this.actionsOpen = true;
        },
        closeActionsMenu(document) {
            this.actionsOpen = false;
            Vue.delete(document, "actions");
        },
        resetDocument() {
            this.newDocument = {
                file: null,
                specialist_name: null,
                title: null,
                type: null,
                notes: null,
                date: null,
            };
        },
        edit(document) {
            this.showUpload = true;
            this.is_edit = true;
            this.newDocument = document;
            this.newDocument.date = new Date(document.date);
        },
        updateDocument() {
            let updateEndPoint = `/api/patients/${this.patient.id}/documents/${
                this.newDocument.id
            }`;
            Vue.delete(this.newDocument, "attaching_file");
            Vue.delete(this.newDocument, "file_url");
            let postDocument = this.newDocument;
            postDocument.date = this.isoDate;
            axios
                .patch(updateEndPoint, postDocument)
                .then(r => {
                    this.showUpload = false;
                    this.is_edit = false;
                    this.resetDocument();
                    this.getData();
                })
                .catch(function(err) {
                    console.error(err);
                });
        },
        deleteDocument(document) {
            let deleteUrl = `/api/patients/${this.patient.id}/documents/${document.id}`;
            axios
                .delete(deleteUrl)
                .then(r => {
                    this.getData();
                    this.actionsOpen = false;
                })
                .catch(e => {});
        },
        getData() {
            let endpoint = `/api/patients/${this.patient.id}/documents`;
            axios
                .get(endpoint)
                .then(r => {
                    this.newData = {};
                    this.editing = false;
                    this.documents = r.data.data;
                })
                .catch(e => {
                    console.error(e);
                });
        },
        handleUpload(event, fieldRef, document) {
            let files = event.target.files || event.dataTransfer.files;
            if (!files.length) return;
            let data = new FormData();
            let uploadEndpoint = `/api/patients/${this.patient.id}/documents/${
                document.id
            }/uploadFile`;
            data.append("file", files[0]);
            data.append("id", document.id);
            axios
                .post(uploadEndpoint, data)
                .then(r => {
                    this.getData();
                    Vue.delete(document, "attaching_file");
                })
                .catch(function(err) {
                    console.error(err);
                });
        },
        updateFile(document) {
            Vue.set(document, "attaching_file", true);
        },
        addDocument() {
            let saveEndpoint = `/api/patients/${this.patient.id}/documents`;
            let postDocument = this.newDocument;
            postDocument.date = this.isoDate;
            axios
                .post(saveEndpoint, this.newDocument)
                .then(r => {
                    this.resetDocument();
                    this.getData();
                    this.showUpload = false;
                })
                .catch(function(err) {
                    console.error(err);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.overlay {
    div[class^="col-"] {
        opacity: 0.2;
    }
}
.actions {
    z-index: 3;
    width: 280px;
    top: 1rem;
    right: 0;
    left: 0;
    margin: 0 auto;
    border: solid 1px #8f8f8f;
    opacity: 1;
    > a {
        opacity: 1;
    }
}
.table-header {
    background-color: #323337;
}
.table-row {
    border: 1px solid lightgray;
}
.table-row:not(:last-child) {
    background-color: white;
    border-top: solid 1px lightgray;
}
.table-row:last-child {
    background-color: white;
}
.pop-up {
    border: solid 1px #8f8f8f;
    z-index: 1;
    top: 0;
    left: 0;
}
.filter-options {
    columns: 2;
    list-style: none;
}
</style>
